import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ch" }
const _hoisted_2 = {
  key: 0,
  class: "ch-card"
}
const _hoisted_3 = {
  key: 0,
  viewBox: "0 0 72 72",
  "aria-hidden": "true"
}
const _hoisted_4 = ["stroke-dasharray"]
const _hoisted_5 = { class: "ch-meta" }
const _hoisted_6 = { class: "ch-score" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "ch-slim"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 2,
  class: "ch-error",
  role: "alert"
}
const _hoisted_12 = {
  key: 3,
  class: "ch-loading",
  role: "status"
}
const _hoisted_13 = ["aria-expanded", "onClick"]
const _hoisted_14 = { class: "ch-check-text" }
const _hoisted_15 = { class: "ch-check-title" }
const _hoisted_16 = { class: "ch-check-why" }
const _hoisted_17 = { class: "ch-count" }
const _hoisted_18 = {
  key: 0,
  class: "ch-chev",
  "aria-hidden": "true"
}
const _hoisted_19 = {
  key: 0,
  class: "ch-bar",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 1,
  class: "ch-items"
}
const _hoisted_21 = {
  key: 0,
  class: "ch-forge"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "ch-item-name" }
const _hoisted_24 = {
  key: 0,
  class: "ch-item-team"
}
const _hoisted_25 = { class: "ch-item-detail" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_forge_team = _resolveComponent("forge-team")!
  const _component_ai_create_node = _resolveComponent("ai-create-node")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.bare)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["ch-ring", _ctx.data && _ctx.data.score != null ? 'ch-ring-' + _ctx.band(_ctx.data.score) : 'ch-ring-none'])
          }, [
            (_ctx.data && _ctx.data.score != null)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                  _cache[5] || (_cache[5] = _createElementVNode("circle", {
                    cx: "36",
                    cy: "36",
                    r: "31",
                    class: "ch-ring-track"
                  }, null, -1)),
                  _createElementVNode("circle", {
                    cx: "36",
                    cy: "36",
                    r: "31",
                    class: "ch-ring-fill",
                    "stroke-dasharray": _ctx.ringDash(_ctx.data.score)
                  }, null, 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(_ctx.data && _ctx.data.score != null ? _ctx.data.score : '–'), 1)
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "ch-label" }, "Company health", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.data && _ctx.data.score != null ? _ctx.data.score : '–'), 1),
              (_ctx.data)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.gapCount) + " gap" + _toDisplayString(_ctx.gapCount == 1 ? '' : 's') + " across " + _toDisplayString(_ctx.data.checks.length) + " checks", 1))
                : _createCommentVNode("", true)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "ch-sub" }, "What's missing from the Playbook: people, teams and the accountability chart. Fix a gap and it drops off the next time you open this tab.", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "ai-btn ai-btn-ghost",
            disabled: _ctx.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load()))
          }, _toDisplayString(_ctx.loading ? 'Checking…' : 'Check again'), 9, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    (_ctx.bare)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "What's missing from the Playbook: people, teams and the accountability chart. Fix a gap and it drops off the next time you check.", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "ai-btn ai-btn-ghost",
            disabled: _ctx.loading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.load()))
          }, _toDisplayString(_ctx.loading ? 'Checking…' : 'Check again'), 9, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.error), 1))
      : (!_ctx.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Checking the company…"))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.checks, (c) => {
              return (_openBlock(), _createElementBlock("section", {
                key: c.key,
                class: _normalizeClass(["ch-check", { 'ch-check-done': !c.items.length }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ch-check-head",
                  "aria-expanded": _ctx.open[c.key] ? 'true' : 'false',
                  onClick: ($event: any) => (_ctx.toggle(c.key))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["ch-dot", 'ch-dot-' + (c.total ? _ctx.band(100 * c.ok / c.total) : 'great')]),
                    "aria-hidden": "true"
                  }, null, 2),
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(c.title), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(c.why), 1)
                  ]),
                  _createElementVNode("span", _hoisted_17, [
                    (!c.total)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Nothing to check")
                        ], 64))
                      : (!c.items.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("All " + _toDisplayString(c.total) + " ✓", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(c.ok) + " of " + _toDisplayString(c.total), 1)
                          ], 64))
                  ]),
                  (c.items.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.open[c.key] ? '▴' : '▾'), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_13),
                (c.total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ width: (100 * c.ok / c.total) + '%' })
                      }, null, 4)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.open[c.key] && c.items.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (c.key == 'role' || c.key == 'checklist')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("span", null, _toDisplayString(c.key == 'role' ? 'No role sheet that fits yet?' : 'No Powerlist that fits yet?'), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ai-btn",
                              onClick: ($event: any) => (_ctx.forgeNode = c.key == 'role' ? 'sheet' : 'checklist')
                            }, _toDisplayString(c.key == 'role' ? 'Forge a role sheet' : 'Forge a Powerlist'), 9, _hoisted_22)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shown(c), (it, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "ch-item"
                        }, [
                          _createElementVNode("span", _hoisted_23, [
                            _createTextVNode(_toDisplayString(it.name), 1),
                            (it.team)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, " · " + _toDisplayString(it.team), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(it.detail || ''), 1),
                          (it.kind == 'employee' && c.key != 'chart')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: '/employee/' + it.id,
                                class: "ch-fix"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.fixLabel(c.key)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (c.key == 'chart')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  to: "/accountability-chart",
                                  class: "ch-fix"
                                }, {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("Open the chart", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (c.key == 'scorecard')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "ch-fix ch-fix-forge",
                                    onClick: ($event: any) => (_ctx.openForge('scorecard', it.name))
                                  }, "Draft with the Forge", 8, _hoisted_26))
                                : (c.key == 'rocks')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 3,
                                      type: "button",
                                      class: "ch-fix ch-fix-forge",
                                      onClick: ($event: any) => (_ctx.openForge('rocks', it.name))
                                    }, "Draft with the Forge", 8, _hoisted_27))
                                  : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      (c.items.length > _ctx.limit && !_ctx.all[c.key])
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "ch-more",
                            onClick: ($event: any) => (_ctx.all[c.key] = true)
                          }, "Show all " + _toDisplayString(c.items.length), 9, _hoisted_28))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "ch-note" }, "Coming next: checks against the Ironbook methodology itself, such as the processes a company like yours should have written down.", -1))
          ], 64)),
    (_ctx.forge)
      ? (_openBlock(), _createBlock(_component_forge_team, {
          key: 5,
          modal: "",
          only: [ _ctx.forge.kind ],
          "start-kind": _ctx.forge.kind,
          "preset-team": _ctx.forge.team,
          onApplied: _cache[2] || (_cache[2] = ($event: any) => (_ctx.load())),
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.forge = null))
        }, null, 8, ["only", "start-kind", "preset-team"]))
      : _createCommentVNode("", true),
    (_ctx.forgeNode)
      ? (_openBlock(), _createBlock(_component_ai_create_node, {
          key: 6,
          "node-type": _ctx.forgeNode,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.forgeNode = ''))
        }, null, 8, ["node-type"]))
      : _createCommentVNode("", true)
  ]))
}